import { memo } from 'react';
import PropTypes from 'prop-types';
import MarkdownToHtml from '../../../../MarkdownToHtml';

const ItineraryDetails = ({ content }) => <MarkdownToHtml content={content || ''} />;
ItineraryDetails.propTypes = {
  content: PropTypes.string.isRequired,
};

export default memo(ItineraryDetails);
